import { render, staticRenderFns } from "./OneProductFilesSection.vue?vue&type=template&id=34c3d7d8&scoped=true&lang=pug&"
import script from "./OneProductFilesSection.vue?vue&type=script&lang=ts&"
export * from "./OneProductFilesSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c3d7d8",
  null
  
)

export default component.exports